// This file contains the bulk of socket functionality for both teachers and students
// in an online discussion
import { mapGetters } from 'vuex';
import { enterPusherChannelAndBindEvents, leavePusherChannel } from 'utils/realTimeEventHelpers';

import roundtableService from 'features/onlineRoundtables/onlineRoundtables.services';

const general_roundtable_events = [
  {
    event_name: 'edit_submission',
    handler: async (payload, { $store }) => {
      try {
        console.log(payload, 'payload');
        const data = (typeof payload === 'object') ? payload : (await roundtableService.viewSubmission(payload)).data;
        console.log(data, 'data');
        $store.commit('UPDATE_SUBMISSION_SPREAD', data);
      } catch (error) {
        console.error('Error updating submission spread:', error);
      }
    },
  },

  {
    event_name: 'delete_submission',
    handler: (submission, context) => {
      if (submission.id === context.getMyRTUserDetails.submission_id) {
        context.$store.commit('UPDATE_SUBMISSION_SPREAD', submission);
        context.$router.push({ name: 'roundtable.prompt', params: context.$route.params });
        context.$store.commit('setIsReloadComponent');
      } else {
        context.$store.commit('UPDATE_SUBMISSION_SPREAD', submission);
      }
    },
  },

  {
    event_name: 'new_submission',
    handler: async (submission, context) => {
      context.$store.dispatch('loadSubmission', submission.id);
    },
  },

  {
    event_name: 'new_comment',
    handler: (comment, context) => {
      if (!context.is_author) {
        if (!comment.is_model_submission) {
          if (!comment.recap_id) {
            context.$store.commit('INCREMENT_SUBMISSION_COMMENT_COUNT', comment.submission_id);
          } else {
            context.$store.commit('INCREMENT_RECAP_COMMENT_COUNT', comment);
          }
        }
        if (!comment.recap_id) {
          context.$store.dispatch('SOCKET_addSubmissionComment', comment);
        } else {
          context.$store.commit('ADD_RECAP_COMMENT', comment);
        }
      }
    },
  },

  {
    event_name: 'comment_updated',
    action_name: 'SOCKET_updateComment',
  },

  {
    event_name: 'star_updates',
    action_name: 'updateStarCount',
  },

  {
    event_name: 'toggle_end_roundtable',
    action_name: 'updateRTDetails',
  },
  {
    event_name: 'genie_grader_start',
    action_name: 'UpdateGenieGraderRunning',
  },
  {
    event_name: 'genie_grader_individual',
    action_name: 'UpdateGenieGraderRunningIndividual',
  },
  {
    event_name: 'update_genie_recap',
    action_name: 'socket_updateGenieRecap',
  },
];

const teacher_only_roundtable_events = [
  {
    event_name: 'new_submission_for_teacher_view',
    handler: (submission, context) => {
      context.$store.dispatch('loadSubmission', submission.id);
    },
  },

  {
    event_name: 'new_comment_for_teacher',
    handler: (comment, context) => {
      if (!comment.is_model_submission) {
        if (!comment.recap_id) {
          context.$store.commit('INCREMENT_SUBMISSION_COMMENT_COUNT', comment.submission_id);
        } else {
          context.$store.commit('INCREMENT_RECAP_COMMENT_COUNT', comment);
        }
      }
      if (context.is_author && comment.user_id !== context.getMyRTUserDetails.id) {
        if (!comment.recap_id) {
          context.$store.dispatch('SOCKET_addSubmissionComment', comment);
        } else {
          context.$store.commit('ADD_RECAP_COMMENT', comment);
        }
      }
    },
  },
];

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters([
      'hasTeacherPermissionsInCourse',
      'getMyRTUserDetails',
      'getCurrentRT',
    ]),
    is_author() {
      return this.hasTeacherPermissionsInCourse;
    },
  },
  methods: {
    setupRoundtableSocket(roundtable_id) {
      enterPusherChannelAndBindEvents.call(
        this,
        roundtable_id,
        general_roundtable_events
      );
      if (this.hasTeacherPermissionsInCourse) {
        enterPusherChannelAndBindEvents.call(
          this,
          `teacher-${roundtable_id}`,
          teacher_only_roundtable_events
        );
      }
    },
    leaveRoundtableSocket(roundtable_id) {
      leavePusherChannel(roundtable_id);
      if (this.hasTeacherPermissionsInCourse) {
        leavePusherChannel(`teacher-${roundtable_id}`);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/mixins/sockets/onlineRoundtableSocketEvents.js